import { config, handleResponse } from '../../_helpers';

export const scheduleServices = {
    load,
    getVoyageScheduleByVoyageNum,
    createVoyageSchedules,
    editVoyageSchedules,
    deleteVoyageSchedules,
    activation,
    scheduleReport,
    getDestinationFromVoyageScheduleByVoyageNum,
    approveSchedule,
    updateCROStatus,
};

function load(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/VoyageSchedules/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/VoyageSchedules/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function getVoyageScheduleByVoyageNum(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };

    // return fetch(`${config.apiUrl}/VoyageSchedules/getVoyage/${voyageNum}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/VoyageSchedules/getVoyageV1/${voyageNum}`, requestOptions).then(handleResponse);
}

function createVoyageSchedules(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    // return fetch(`${config.apiUrl}/voyageSchedules`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/VoyageSchedules/createcheduleV1`, requestOptions).then(handleResponse);
}

function editVoyageSchedules(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    // return fetch(`${config.apiUrl}/voyageSchedules/update/${id}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/voyageSchedules/updateV1/${id}`, requestOptions).then(handleResponse);
}

function deleteVoyageSchedules(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VoyageSchedules/delete`, requestOptions).then(handleResponse);
}

function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };

    return fetch(`${config.apiUrl}/VoyageSchedules/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}

function scheduleReport(from, to, vessel) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(vessel),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/VoyageSchedules/GenerateReports?DateFrom=${from}&DateTo=${to}`, requestOptions).then(handleResponse);
}

function getDestinationFromVoyageScheduleByVoyageNum(voyageNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/VoyageSchedules/get/${voyageNum}`, requestOptions).then(handleResponse);
}

function approveSchedule(voyageNum) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/VoyageSchedules/approve/${voyageNum}`, requestOptions).then(handleResponse);
}

function updateCROStatus(voyageNum, status) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(status),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    
    return fetch(`${config.apiUrl}/VoyageSchedules/updateCROStatus/${voyageNum}`, requestOptions).then(handleResponse);
}